import { render, staticRenderFns } from "./ExternalSupportEditor.vue?vue&type=template&id=bea6a3e2&scoped=true&"
import script from "./ExternalSupportEditor.vue?vue&type=script&lang=ts&"
export * from "./ExternalSupportEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalSupportEditor.vue?vue&type=style&index=0&id=bea6a3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea6a3e2",
  null
  
)

export default component.exports